import script from "./GalleryTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./GalleryTopComponent.vue?vue&type=style&index=0&id=547a875e&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547a875e"]])

export default __exports__